import React from 'react';
import EmptyStateBasic from 'shared/components/EmptyStateBasic';

import LineChart from '../features/charts/components/LineChart';

import {
  PageSection,
  PageSectionVariants,
  Bullseye,
  Spinner,
  Content,
  ContentVariants,
  Divider
} from '@patternfly/react-core';

class Charts extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      charts_data: {},
      isLoadedCharts: false,
      error: null
    }
  }

  GetCharts = async (args) => {
    try {
      const resp = await fetch(
        `${this.props.state.api_url}/ti/api/v1${args}`,
        { method: 'GET' }
      );

      const data = await resp.json();

      this.setState({
        charts_data: data,
        isLoadedCharts: true
      });

    } catch (err) {
      this.setState({
        error: err,
        isLoadedCharts: false
      });
    }
  }

  componentDidMount() {
    this.setState({ isLoadedCharts: false });
    this.GetCharts(window.location.pathname);
  }

  renderLoading() {
    return (
      <Bullseye style={{ height: '100vh' }}>
        <div style={{ textAlign: "center" }}>
          <h1>Wyniki testów</h1>
          <Spinner size="xl" />
        </div>
      </Bullseye>
    );
  }

  render() {

    const results =
      this.state.charts_data?.results_for_qualifications || {};

    if (!this.state.isLoadedCharts) {
      return this.renderLoading();
    }

    if (Object.keys(results).length === 0) {
      return <EmptyStateBasic />;
    }

    // const execution_time = this.state.charts_data.execution_time;

    return (
      <>
        {/* <Banner>
          <Level>
            <LevelItem />
            <LevelItem>
              Execution time: {execution_time}
            </LevelItem>
          </Level>
        </Banner> */}

        <PageSection variant={PageSectionVariants.light}>

          {results["INF02"] && (
            <>
              <Content component={ContentVariants.p}>
                INF.02 Średnie wyniki testów teoretycznych
              </Content>
              <Divider />
              <LineChart
                qn="inf02"
                isLoadedCharts={this.state.isLoadedCharts}
                qualification={results.INF02}
              />
              
            </>
          )}

          {results["INF03"] && (
            <>
              <Content component={ContentVariants.p}>
                INF.03 Średnie wyniki testów teoretycznych
              </Content>
              <Divider />

              <LineChart
                qn="inf03"
                isLoadedCharts={this.state.isLoadedCharts}
                qualification={results.INF03}
              />
            </>
          )}

          {results["INF04"] && (
            <>
              <Content component={ContentVariants.p}>
                INF.04 Średnie wyniki testów teoretycznych
              </Content>
              <Divider />

              <LineChart
                qn="inf04"
                isLoadedCharts={this.state.isLoadedCharts}
                qualification={results.INF04}
              />
            </>
          )}

        </PageSection>
      </>
    );
  }
}

export default Charts;